import styled from '@emotion/styled';

import { breakpoints, colors } from '@datacamp/waffles-tokens';

export const Wrapper = styled.div`
  padding: 12px 0;
  color: ${colors.white};
  background: ${colors.primaryDarkest};
`;

export const Container = styled.div`
  margin-left: auto;
  margin-right: auto;
  padding-left: 16px;
  padding-right: 16px;

  &:before {
    content: ' ';
    display: table;
  }

  &:after {
    content: ' ';
    display: table;
    clear: both;
  }

  @media screen and (min-width: ${breakpoints.sm}) {
    width: 750px;
  }

  @media screen and (min-width: ${breakpoints.md}) {
    width: 970px;
  }

  @media screen and (min-width: ${breakpoints.lg}) {
    width: 1170px;
  }
`;
